import React, { useEffect, useState } from 'react';
import api from './PlanMock.js';
import { Alert } from 'react-bootstrap';
import '../styles/UserProfile.css';

const UserProfile = ({userRole, bearerToken}) => {
  const [profileData, setProfileData] = useState(null);
  const [profileError, setProfileError] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get('/profile');
        setProfileData(res.data);
      } catch (error) {
        setProfileError('Unable to fetch profile data');
      }
    };
    fetchProfile();
  }, []);


  return (
    <div className="user-profile-container">
      {profileError && (
        <Alert variant="danger" style={{ width: '80%', margin: '4%' }}>
          {profileError}
        </Alert>
      )}

      {profileData && (
        <div className="card-style">
          <h1 className="profile-heading">User Profile</h1>
          <div className="divider-style"></div>

          <div className="profile-grid">
            {/* Row 1 */}
            <div className="grid-row">
              <span className="label-style">Name</span>
              <span className="value-style">{profileData.name}</span>
            </div>
            {/* Row 2 */}
            <div className="grid-row">
              <span className="label-style">Email</span>
              <span className="value-style">{profileData.email}</span>
            </div>
            {/* Row 3 */}
            <div className="grid-row">
              <span className="label-style">Mobile Number</span>
              <span className="value-style">{profileData.phone}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
